import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import * as moment from 'moment';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { GlobalFunctionService } from '@providers/global-function/global-function.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var BalanceComponent = /** @class */ (function () {
    function BalanceComponent(globalDataService, requestService, globalFunction, requestV2Service) {
        this.globalDataService = globalDataService;
        this.requestService = requestService;
        this.globalFunction = globalFunction;
        this.requestV2Service = requestV2Service;
        this.transactions = [];
        this.payments = [];
        this.invoices = [];
        this.invoicesNeedToPay = [];
        this.paymentsNotInvoiced = [];
        this.totalTransactionAmount = 0;
        this.totalPaymentAmount = 0;
        this.totalInvoiceHistory = 0;
        this.paymentProgress = 0;
        this.status = 'loading';
    }
    BalanceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.status = 'loading';
        this.projectObserver = this.globalDataService
            .getCurrentProject()
            .subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var paymentResults;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!project || this.project) {
                            return [2 /*return*/];
                        }
                        this.project = project;
                        return [4 /*yield*/, this.requestV2Service.getProjectPayments(project.id)];
                    case 1:
                        paymentResults = _a.sent();
                        this.payments = paymentResults.items;
                        this.calculateTotalPayment();
                        this.getTransactions(project.id);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BalanceComponent.prototype.ngOnDestroy = function () {
        this.projectObserver.unsubscribe();
    };
    BalanceComponent.prototype.getTransactions = function (projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var transactionResults, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.requestV2Service.getTransactions(projectId, true)];
                    case 1:
                        transactionResults = _a.sent();
                        this.transactions = transactionResults.items;
                        this.calculateTotalTransaction();
                        this.calculatePaymentCompletion();
                        this.getInvoices(projectId);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.status = 'idle';
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BalanceComponent.prototype.getInvoices = function (projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var invoicesResults;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestV2Service.getInvoices(projectId, true)];
                    case 1:
                        invoicesResults = _a.sent();
                        this.invoices = invoicesResults.items;
                        this.invoices.forEach(function (invoice) {
                            invoice.totalPrice = invoice._related.invoice_lines.reduce(function (acc, invoiceLine) {
                                var price = invoiceLine.unit_price * invoiceLine.unit_quantity;
                                var vat = Object.keys(invoiceLine.vat).reduce(function (acc2, item) {
                                    return acc2 + invoiceLine.vat[item];
                                }, 0);
                                return acc + price + vat;
                            }, 0);
                            _this.totalInvoiceHistory += invoice.totalPrice;
                        });
                        this.calculateInvoicesCompletion();
                        this.fillPayments();
                        this.fillNeedToPay();
                        return [2 /*return*/];
                }
            });
        });
    };
    BalanceComponent.prototype.fillPayments = function () {
        var _this = this;
        this.payments.forEach(function (payment) {
            var existPayment = _this.invoices.find(function (i) { return i.id_payment === payment.id; });
            if (typeof existPayment === 'undefined') {
                _this.paymentsNotInvoiced.push(payment);
            }
        });
    };
    BalanceComponent.prototype.fillNeedToPay = function () {
        var _this = this;
        this.invoices.forEach(function (invoice) {
            var alreadyPaidAmount = _this.transactions.reduce(function (acc, transaction) {
                return acc + transaction._related.transaction_allocations.reduce(function (acc2, bd) {
                    if (bd.id_invoice === invoice.id) {
                        return acc2 + bd.amount;
                    }
                    return acc2;
                }, 0);
            }, 0);
            var totalInvoice = invoice._related.invoice_lines.reduce(function (acc, line) {
                var price = line.unit_price * line.unit_quantity;
                var vat = Object.keys(line.vat).reduce(function (acc2, item) {
                    return acc2 + line.vat[item];
                }, 0);
                return acc + price + vat;
            }, 0);
            if (totalInvoice - alreadyPaidAmount > 0) {
                if (moment().isBefore(moment(invoice.date_limit))) {
                    _this.invoicesNeedToPay.push({
                        date: invoice.date_limit,
                        amount: totalInvoice - alreadyPaidAmount,
                        status: 'in-time'
                    });
                }
                else {
                    _this.invoicesNeedToPay.push({
                        date: invoice.date_limit,
                        amount: totalInvoice - alreadyPaidAmount,
                        status: 'late'
                    });
                }
            }
        });
        this.totalPaymentAmount = this.invoicesNeedToPay.reduce(function (acc, item) { return acc + item.amount; }, 0);
    };
    BalanceComponent.prototype.calculateInvoicesCompletion = function () {
        var _this = this;
        this.transactions.forEach(function (transaction) {
            transaction._related.transaction_allocations.forEach(function (breakdown) {
                var invoice = _this.getInvoiceWithId(breakdown.id_invoice);
                if (invoice == null) {
                    return;
                }
                if (invoice.paid === undefined) {
                    invoice.paid = 0;
                }
                invoice.paid += breakdown.amount;
            });
        });
        var paymentsPaidIds = [];
        this.invoices.forEach(function (invoice) {
            invoice.paidPercent = Math.round((invoice.paid / invoice.totalPrice) * 100);
            // Filter paid payments
            if (invoice.paidPercent >= 100) {
                paymentsPaidIds.push(invoice.id_payment);
            }
        });
        this.payments = this.payments.filter(function (payment) {
            return !paymentsPaidIds.includes(payment.id);
        });
        var progress = Math.round((this.totalTransactionAmount / this.totalInvoiceHistory) * 100);
        this.paymentProgress = progress >= 100 ? 100 : progress;
        this.status = 'idle';
    };
    BalanceComponent.prototype.getInvoiceWithId = function (invoiceId) {
        var e_2, _a;
        try {
            for (var _b = tslib_1.__values(this.invoices), _c = _b.next(); !_c.done; _c = _b.next()) {
                var invoice = _c.value;
                if (invoice.id === invoiceId) {
                    return invoice;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return null;
    };
    BalanceComponent.prototype.calculatePaymentCompletion = function () {
        if (!this.transactions ||
            this.transactions.length <= 0 ||
            !this.payments ||
            this.payments.length <= 0) {
            return;
        }
        var totalTransaction = this.totalTransactionAmount;
        if (totalTransaction === 0) {
            return;
        }
        this.payments.forEach(function (payment) {
            if (totalTransaction <= 0) {
                payment.completion = 0;
                return;
            }
            if (totalTransaction >= payment.amount) {
                payment.completion = 100;
            }
            else {
                payment.completion = Math.round((totalTransaction / payment.amount) * 100.0);
            }
            totalTransaction -= payment.amount;
        });
    };
    BalanceComponent.prototype.calculateTotalTransaction = function () {
        var total = 0;
        this.transactions.forEach(function (transaction) {
            if (transaction.type === 'DEBIT') {
                total -= transaction.amount;
            }
            else {
                total += transaction.amount;
            }
        });
        this.totalTransactionAmount = total;
    };
    BalanceComponent.prototype.calculateTotalPayment = function () {
        var total = 0;
        this.payments.forEach(function (payment) {
            total += payment.amount;
        });
        this.totalPaymentAmount = total;
    };
    return BalanceComponent;
}());
export { BalanceComponent };
